import React from 'react'
import { CategoryTitle, Text } from 'components'

const PaymentMethods = ({ conditions }) => {
  if (!conditions) return null

  return (
    <section>
      <CategoryTitle title="Formas de Pagamento" icon="payment" />
      {conditions.map((condition, index) => (
        <Text key={index.toString()} fontSize="medium" color="lightTextColor">
          {condition.title}
        </Text>
      ))}
    </section>
  )
}

export default PaymentMethods
